import type {FragmentDefinitionNode} from 'graphql';

export function isDefinedOnQuery(node: FragmentDefinitionNode): boolean {
  return node.typeCondition.name.value === 'Query';
}
